module.exports = __webpack_public_path__ + "static/img/shi3_2.7ccaaed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi3_2.png
// module id = rXol
// module chunks = 1